<template>
    <i :class="'iu-icon-' + name"></i>
</template>

<script>
export default {
    name: 'IuIcon',
    props: {
        name: String,
    },
};
</script>
<style scope>
@font-face {
    font-family: element-icons;
    src: url(../../../fonts/element-icons.woff) format('woff'), url(../../../fonts/element-icons.ttf) format('truetype');
    font-weight: 400;
    font-display: 'auto';
    font-style: normal;
}
[class*=' iu-icon-'],
[class^='iu-icon-'] {
    font-family: element-icons !important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.iu-icon-ice-cream-round:before {
    content: '\e6a0';
}
.iu-icon-ice-cream-square:before {
    content: '\e6a3';
}
.iu-icon-lollipop:before {
    content: '\e6a4';
}
.iu-icon-potato-strips:before {
    content: '\e6a5';
}
.iu-icon-milk-tea:before {
    content: '\e6a6';
}
.iu-icon-ice-drink:before {
    content: '\e6a7';
}
.iu-icon-ice-tea:before {
    content: '\e6a9';
}
.iu-icon-coffee:before {
    content: '\e6aa';
}
.iu-icon-orange:before {
    content: '\e6ab';
}
.iu-icon-pear:before {
    content: '\e6ac';
}
.iu-icon-apple:before {
    content: '\e6ad';
}
.iu-icon-cherry:before {
    content: '\e6ae';
}
.iu-icon-watermelon:before {
    content: '\e6af';
}
.iu-icon-grape:before {
    content: '\e6b0';
}
.iu-icon-refrigerator:before {
    content: '\e6b1';
}
.iu-icon-goblet-square-full:before {
    content: '\e6b2';
}
.iu-icon-goblet-square:before {
    content: '\e6b3';
}
.iu-icon-goblet-full:before {
    content: '\e6b4';
}
.iu-icon-goblet:before {
    content: '\e6b5';
}
.iu-icon-cold-drink:before {
    content: '\e6b6';
}
.iu-icon-coffee-cup:before {
    content: '\e6b8';
}
.iu-icon-water-cup:before {
    content: '\e6b9';
}
.iu-icon-hot-water:before {
    content: '\e6ba';
}
.iu-icon-ice-cream:before {
    content: '\e6bb';
}
.iu-icon-dessert:before {
    content: '\e6bc';
}
.iu-icon-sugar:before {
    content: '\e6bd';
}
.iu-icon-tableware:before {
    content: '\e6be';
}
.iu-icon-burger:before {
    content: '\e6bf';
}
.iu-icon-knife-fork:before {
    content: '\e6c1';
}
.iu-icon-fork-spoon:before {
    content: '\e6c2';
}
.iu-icon-chicken:before {
    content: '\e6c3';
}
.iu-icon-food:before {
    content: '\e6c4';
}
.iu-icon-dish-1:before {
    content: '\e6c5';
}
.iu-icon-dish:before {
    content: '\e6c6';
}
.iu-icon-moon-night:before {
    content: '\e6ee';
}
.iu-icon-moon:before {
    content: '\e6f0';
}
.iu-icon-cloudy-and-sunny:before {
    content: '\e6f1';
}
.iu-icon-partly-cloudy:before {
    content: '\e6f2';
}
.iu-icon-cloudy:before {
    content: '\e6f3';
}
.iu-icon-sunny:before {
    content: '\e6f6';
}
.iu-icon-sunset:before {
    content: '\e6f7';
}
.iu-icon-sunrise-1:before {
    content: '\e6f8';
}
.iu-icon-sunrise:before {
    content: '\e6f9';
}
.iu-icon-heavy-rain:before {
    content: '\e6fa';
}
.iu-icon-lightning:before {
    content: '\e6fb';
}
.iu-icon-light-rain:before {
    content: '\e6fc';
}
.iu-icon-wind-power:before {
    content: '\e6fd';
}
.iu-icon-baseball:before {
    content: '\e712';
}
.iu-icon-soccer:before {
    content: '\e713';
}
.iu-icon-football:before {
    content: '\e715';
}
.iu-icon-basketball:before {
    content: '\e716';
}
.iu-icon-ship:before {
    content: '\e73f';
}
.iu-icon-truck:before {
    content: '\e740';
}
.iu-icon-bicycle:before {
    content: '\e741';
}
.iu-icon-mobile-phone:before {
    content: '\e6d3';
}
.iu-icon-service:before {
    content: '\e6d4';
}
.iu-icon-key:before {
    content: '\e6e2';
}
.iu-icon-unlock:before {
    content: '\e6e4';
}
.iu-icon-lock:before {
    content: '\e6e5';
}
.iu-icon-watch:before {
    content: '\e6fe';
}
.iu-icon-watch-1:before {
    content: '\e6ff';
}
.iu-icon-timer:before {
    content: '\e702';
}
.iu-icon-alarm-clock:before {
    content: '\e703';
}
.iu-icon-map-location:before {
    content: '\e704';
}
.iu-icon-delete-location:before {
    content: '\e705';
}
.iu-icon-add-location:before {
    content: '\e706';
}
.iu-icon-location-information:before {
    content: '\e707';
}
.iu-icon-location-outline:before {
    content: '\e708';
}
.iu-icon-location:before {
    content: '\e79e';
}
.iu-icon-place:before {
    content: '\e709';
}
.iu-icon-discover:before {
    content: '\e70a';
}
.iu-icon-first-aid-kit:before {
    content: '\e70b';
}
.iu-icon-trophy-1:before {
    content: '\e70c';
}
.iu-icon-trophy:before {
    content: '\e70d';
}
.iu-icon-medal:before {
    content: '\e70e';
}
.iu-icon-medal-1:before {
    content: '\e70f';
}
.iu-icon-stopwatch:before {
    content: '\e710';
}
.iu-icon-mic:before {
    content: '\e711';
}
.iu-icon-copy-document:before {
    content: '\e718';
}
.iu-icon-full-screen:before {
    content: '\e719';
}
.iu-icon-switch-button:before {
    content: '\e71b';
}
.iu-icon-aim:before {
    content: '\e71c';
}
.iu-icon-crop:before {
    content: '\e71d';
}
.iu-icon-odometer:before {
    content: '\e71e';
}
.iu-icon-time:before {
    content: '\e71f';
}
.iu-icon-bangzhu:before {
    content: '\e724';
}
.iu-icon-close-notification:before {
    content: '\e726';
}
.iu-icon-microphone:before {
    content: '\e727';
}
.iu-icon-turn-off-microphone:before {
    content: '\e728';
}
.iu-icon-position:before {
    content: '\e729';
}
.iu-icon-postcard:before {
    content: '\e72a';
}
.iu-icon-message:before {
    content: '\e72b';
}
.iu-icon-chat-line-square:before {
    content: '\e72d';
}
.iu-icon-chat-dot-square:before {
    content: '\e72e';
}
.iu-icon-chat-dot-round:before {
    content: '\e72f';
}
.iu-icon-chat-square:before {
    content: '\e730';
}
.iu-icon-chat-line-round:before {
    content: '\e731';
}
.iu-icon-chat-round:before {
    content: '\e732';
}
.iu-icon-set-up:before {
    content: '\e733';
}
.iu-icon-turn-off:before {
    content: '\e734';
}
.iu-icon-open:before {
    content: '\e735';
}
.iu-icon-connection:before {
    content: '\e736';
}
.iu-icon-link:before {
    content: '\e737';
}
.iu-icon-cpu:before {
    content: '\e738';
}
.iu-icon-thumb:before {
    content: '\e739';
}
.iu-icon-female:before {
    content: '\e73a';
}
.iu-icon-male:before {
    content: '\e73b';
}
.iu-icon-guide:before {
    content: '\e73c';
}
.iu-icon-news:before {
    content: '\e73e';
}
.iu-icon-price-tag:before {
    content: '\e744';
}
.iu-icon-discount:before {
    content: '\e745';
}
.iu-icon-wallet:before {
    content: '\e747';
}
.iu-icon-coin:before {
    content: '\e748';
}
.iu-icon-money:before {
    content: '\e749';
}
.iu-icon-bank-card:before {
    content: '\e74a';
}
.iu-icon-box:before {
    content: '\e74b';
}
.iu-icon-present:before {
    content: '\e74c';
}
.iu-icon-sell:before {
    content: '\e6d5';
}
.iu-icon-sold-out:before {
    content: '\e6d6';
}
.iu-icon-shopping-bag-2:before {
    content: '\e74d';
}
.iu-icon-shopping-bag-1:before {
    content: '\e74e';
}
.iu-icon-shopping-cart-2:before {
    content: '\e74f';
}
.iu-icon-shopping-cart-1:before {
    content: '\e750';
}
.iu-icon-shopping-cart-full:before {
    content: '\e751';
}
.iu-icon-smoking:before {
    content: '\e752';
}
.iu-icon-no-smoking:before {
    content: '\e753';
}
.iu-icon-house:before {
    content: '\e754';
}
.iu-icon-table-lamp:before {
    content: '\e755';
}
.iu-icon-school:before {
    content: '\e756';
}
.iu-icon-office-building:before {
    content: '\e757';
}
.iu-icon-toilet-paper:before {
    content: '\e758';
}
.iu-icon-notebook-2:before {
    content: '\e759';
}
.iu-icon-notebook-1:before {
    content: '\e75a';
}
.iu-icon-files:before {
    content: '\e75b';
}
.iu-icon-collection:before {
    content: '\e75c';
}
.iu-icon-receiving:before {
    content: '\e75d';
}
.iu-icon-suitcase-1:before {
    content: '\e760';
}
.iu-icon-suitcase:before {
    content: '\e761';
}
.iu-icon-film:before {
    content: '\e763';
}
.iu-icon-collection-tag:before {
    content: '\e765';
}
.iu-icon-data-analysis:before {
    content: '\e766';
}
.iu-icon-pie-chart:before {
    content: '\e767';
}
.iu-icon-data-board:before {
    content: '\e768';
}
.iu-icon-data-line:before {
    content: '\e76d';
}
.iu-icon-reading:before {
    content: '\e769';
}
.iu-icon-magic-stick:before {
    content: '\e76a';
}
.iu-icon-coordinate:before {
    content: '\e76b';
}
.iu-icon-mouse:before {
    content: '\e76c';
}
.iu-icon-brush:before {
    content: '\e76e';
}
.iu-icon-headset:before {
    content: '\e76f';
}
.iu-icon-umbrella:before {
    content: '\e770';
}
.iu-icon-scissors:before {
    content: '\e771';
}
.iu-icon-mobile:before {
    content: '\e773';
}
.iu-icon-attract:before {
    content: '\e774';
}
.iu-icon-monitor:before {
    content: '\e775';
}
.iu-icon-search:before {
    content: '\e778';
}
.iu-icon-takeaway-box:before {
    content: '\e77a';
}
.iu-icon-paperclip:before {
    content: '\e77d';
}
.iu-icon-printer:before {
    content: '\e77e';
}
.iu-icon-document-add:before {
    content: '\e782';
}
.iu-icon-document:before {
    content: '\e785';
}
.iu-icon-document-checked:before {
    content: '\e786';
}
.iu-icon-document-copy:before {
    content: '\e787';
}
.iu-icon-document-delete:before {
    content: '\e788';
}
.iu-icon-document-remove:before {
    content: '\e789';
}
.iu-icon-tickets:before {
    content: '\e78b';
}
.iu-icon-folder-checked:before {
    content: '\e77f';
}
.iu-icon-folder-delete:before {
    content: '\e780';
}
.iu-icon-folder-remove:before {
    content: '\e781';
}
.iu-icon-folder-add:before {
    content: '\e783';
}
.iu-icon-folder-opened:before {
    content: '\e784';
}
.iu-icon-folder:before {
    content: '\e78a';
}
.iu-icon-edit-outline:before {
    content: '\e764';
}
.iu-icon-edit:before {
    content: '\e78c';
}
.iu-icon-date:before {
    content: '\e78e';
}
.iu-icon-c-scale-to-original:before {
    content: '\e7c6';
}
.iu-icon-view:before {
    content: '\e6ce';
}
.iu-icon-loading:before {
    content: '\e6cf';
}
.iu-icon-rank:before {
    content: '\e6d1';
}
.iu-icon-sort-down:before {
    content: '\e7c4';
}
.iu-icon-sort-up:before {
    content: '\e7c5';
}
.iu-icon-sort:before {
    content: '\e6d2';
}
.iu-icon-finished:before {
    content: '\e6cd';
}
.iu-icon-refresh-left:before {
    content: '\e6c7';
}
.iu-icon-refresh-right:before {
    content: '\e6c8';
}
.iu-icon-refresh:before {
    content: '\e6d0';
}
.iu-icon-video-play:before {
    content: '\e7c0';
}
.iu-icon-video-pause:before {
    content: '\e7c1';
}
.iu-icon-d-arrow-right:before {
    content: '\e6dc';
}
.iu-icon-d-arrow-left:before {
    content: '\e6dd';
}
.iu-icon-arrow-up:before {
    content: '\e6e1';
}
.iu-icon-arrow-down:before {
    content: '\e6df';
}
.iu-icon-arrow-right:before {
    content: '\e6e0';
}
.iu-icon-arrow-left:before {
    content: '\e6de';
}
.iu-icon-top-right:before {
    content: '\e6e7';
}
.iu-icon-top-left:before {
    content: '\e6e8';
}
.iu-icon-top:before {
    content: '\e6e6';
}
.iu-icon-bottom:before {
    content: '\e6eb';
}
.iu-icon-right:before {
    content: '\e6e9';
}
.iu-icon-back:before {
    content: '\e6ea';
}
.iu-icon-bottom-right:before {
    content: '\e6ec';
}
.iu-icon-bottom-left:before {
    content: '\e6ed';
}
.iu-icon-caret-top:before {
    content: '\e78f';
}
.iu-icon-caret-bottom:before {
    content: '\e790';
}
.iu-icon-caret-right:before {
    content: '\e791';
}
.iu-icon-caret-left:before {
    content: '\e792';
}
.iu-icon-d-caret:before {
    content: '\e79a';
}
.iu-icon-share:before {
    content: '\e793';
}
.iu-icon-menu:before {
    content: '\e798';
}
.iu-icon-s-grid:before {
    content: '\e7a6';
}
.iu-icon-s-check:before {
    content: '\e7a7';
}
.iu-icon-s-data:before {
    content: '\e7a8';
}
.iu-icon-s-opportunity:before {
    content: '\e7aa';
}
.iu-icon-s-custom:before {
    content: '\e7ab';
}
.iu-icon-s-claim:before {
    content: '\e7ad';
}
.iu-icon-s-finance:before {
    content: '\e7ae';
}
.iu-icon-s-comment:before {
    content: '\e7af';
}
.iu-icon-s-flag:before {
    content: '\e7b0';
}
.iu-icon-s-marketing:before {
    content: '\e7b1';
}
.iu-icon-s-shop:before {
    content: '\e7b4';
}
.iu-icon-s-open:before {
    content: '\e7b5';
}
.iu-icon-s-management:before {
    content: '\e7b6';
}
.iu-icon-s-ticket:before {
    content: '\e7b7';
}
.iu-icon-s-release:before {
    content: '\e7b8';
}
.iu-icon-s-home:before {
    content: '\e7b9';
}
.iu-icon-s-promotion:before {
    content: '\e7ba';
}
.iu-icon-s-operation:before {
    content: '\e7bb';
}
.iu-icon-s-unfold:before {
    content: '\e7bc';
}
.iu-icon-s-fold:before {
    content: '\e7a9';
}
.iu-icon-s-platform:before {
    content: '\e7bd';
}
.iu-icon-s-order:before {
    content: '\e7be';
}
.iu-icon-s-cooperation:before {
    content: '\e7bf';
}
.iu-icon-bell:before {
    content: '\e725';
}
.iu-icon-message-solid:before {
    content: '\e799';
}
.iu-icon-video-camera:before {
    content: '\e772';
}
.iu-icon-video-camera-solid:before {
    content: '\e796';
}
.iu-icon-camera:before {
    content: '\e779';
}
.iu-icon-camera-solid:before {
    content: '\e79b';
}
.iu-icon-download:before {
    content: '\e77c';
}
.iu-icon-upload2:before {
    content: '\e77b';
}
.iu-icon-upload:before {
    content: '\e7c3';
}
.iu-icon-picture-outline-round:before {
    content: '\e75f';
}
.iu-icon-picture-outline:before {
    content: '\e75e';
}
.iu-icon-picture:before {
    content: '\e79f';
}
.iu-icon-close:before {
    content: '\e6db';
}
.iu-icon-check:before {
    content: '\e6da';
}
.iu-icon-plus:before {
    content: '\e6d9';
}
.iu-icon-minus:before {
    content: '\e6d8';
}
.iu-icon-help:before {
    content: '\e73d';
}
.iu-icon-s-help:before {
    content: '\e7b3';
}
.iu-icon-circle-close:before {
    content: '\e78d';
}
.iu-icon-circle-check:before {
    content: '\e720';
}
.iu-icon-circle-plus-outline:before {
    content: '\e723';
}
.iu-icon-remove-outline:before {
    content: '\e722';
}
.iu-icon-zoom-out:before {
    content: '\e776';
}
.iu-icon-zoom-in:before {
    content: '\e777';
}
.iu-icon-error:before {
    content: '\e79d';
}
.iu-icon-success:before {
    content: '\e79c';
}
.iu-icon-circle-plus:before {
    content: '\e7a0';
}
.iu-icon-remove:before {
    content: '\e7a2';
}
.iu-icon-info:before {
    content: '\e7a1';
}
.iu-icon-question:before {
    content: '\e7a4';
}
.iu-icon-warning-outline:before {
    content: '\e6c9';
}
.iu-icon-warning:before {
    content: '\e7a3';
}
.iu-icon-goods:before {
    content: '\e7c2';
}
.iu-icon-s-goods:before {
    content: '\e7b2';
}
.iu-icon-star-off:before {
    content: '\e717';
}
.iu-icon-star-on:before {
    content: '\e797';
}
.iu-icon-more-outline:before {
    content: '\e6cc';
}
.iu-icon-more:before {
    content: '\e794';
}
.iu-icon-phone-outline:before {
    content: '\e6cb';
}
.iu-icon-phone:before {
    content: '\e795';
}
.iu-icon-user:before {
    content: '\e6e3';
}
.iu-icon-user-solid:before {
    content: '\e7a5';
}
.iu-icon-setting:before {
    content: '\e6ca';
}
.iu-icon-s-tools:before {
    content: '\e7ac';
}
.iu-icon-delete:before {
    content: '\e6d7';
}
.iu-icon-delete-solid:before {
    content: '\e7c9';
}
.iu-icon-eleme:before {
    content: '\e7c7';
}
.iu-icon-platform-eleme:before {
    content: '\e7ca';
}
.iu-icon-loading {
    -webkit-animation: rotating 2s linear infinite;
    animation: rotating 2s linear infinite;
}
.iu-icon--right {
    margin-left: 5px;
}
.iu-icon--left {
    margin-right: 5px;
}
@-webkit-keyframes rotating {
    0% {
        -webkit-transform: rotateZ(0);
        transform: rotateZ(0);
    }
    100% {
        -webkit-transform: rotateZ(360deg);
        transform: rotateZ(360deg);
    }
}
@keyframes rotating {
    0% {
        -webkit-transform: rotateZ(0);
        transform: rotateZ(0);
    }
    100% {
        -webkit-transform: rotateZ(360deg);
        transform: rotateZ(360deg);
    }
}
</style>
